<section class="about-hero" *ngIf="hero" [style.backgroundImage]="hero.backgroundImage ? 'url(' + hero.backgroundImage + ')' : null" aria-label="About hero">
  <div class="about-hero-content">
    <div class="about-hero-text">
      <h1 class="about-hero-title">{{ hero.eyebrow }}<br><em>{{ hero.title }}</em></h1>
      <p class="about-hero-subtitle">{{ hero.subtitle }}</p>
    </div>
    <a *ngIf="hero.primaryCtaUrl" [routerLink]="hero.primaryCtaUrl" class="about-hero-cta">
      <span>{{ hero.primaryCta }}</span>
      <span aria-hidden="true">↗</span>
    </a>
    <a *ngIf="!hero.primaryCtaUrl && hero.primaryCta" routerLink="/get-started" class="about-hero-cta">
      <span>{{ hero.primaryCta }}</span>
      <span aria-hidden="true">↗</span>
    </a>
  </div>
</section>
